"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.levels = exports.error = exports.warn = exports.info = exports.debug = exports.log = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _analytics = require("./analytics");

var levels = _interopRequireWildcard(require("./constants/logLevels"));

exports.levels = levels;

var _levelsLogFunctions;

var debug = function debug(context) {
  if (process.env.NODE_ENV === 'development') console.log(context.id, context);
};

exports.debug = debug;

var info = function info(context) {
  return console.log(context.id, context);
};

exports.info = info;

var warn = function warn(context) {
  return console.warn(context.id, context);
};

exports.warn = warn;

var error = function error(context) {
  console.error(context.id, context);
  (0, _analytics.exception)({
    description: context.description || context.error && context.error.message || '',
    fatal: Boolean(context.fatal),
    args: context.args || [],
    error: context.error
  });
};

exports.error = error;
var levelsLogFunctions = (_levelsLogFunctions = {}, (0, _defineProperty2["default"])(_levelsLogFunctions, levels.DEBUG, debug), (0, _defineProperty2["default"])(_levelsLogFunctions, levels.INFO, info), (0, _defineProperty2["default"])(_levelsLogFunctions, levels.WARN, warn), (0, _defineProperty2["default"])(_levelsLogFunctions, levels.ERROR, error), _levelsLogFunctions);

var log = function log(level, context) {
  var levelCB = levelsLogFunctions[level] || info;
  levelCB(context);
};

exports.log = log;
var _default = log;
exports["default"] = _default;